/**
 * Render product card markup from REST card payloads.
 */

import { syncFavouriteButtons } from './favourites.js';

function escapeHtml(value) {
	return String(value ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');
}

/**
 * @param {Record<string, unknown>} product
 * @returns {string}
 */
export function renderProductCard(product) {
	const id = Number(product.id);
	const inStock = product.in_stock !== false;
	const stockClass = inStock ? 'in-stock' : 'out-of-stock';
	const stockLabel = inStock ? 'In stock' : 'Out of stock';
	const canQuickAdd = Boolean(product.can_quick_add);
	const canChooseOptions = Boolean(product.can_choose_options);

	let action = '';
	if (canQuickAdd) {
		action = `
			<button
				type="button"
				class="dc-btn dc-btn--secondary dc-btn--sm dc-product-card__quick-add"
				data-quick-add
				data-product-id="${id}"
			>
				<span data-quick-add-label>Quick add</span>
			</button>
		`;
	} else if (canChooseOptions) {
		action = `
			<button
				type="button"
				class="dc-btn dc-btn--secondary dc-btn--sm dc-product-card__quick-add"
				data-choose-options
				data-product-id="${id}"
			>
				<span>Choose options</span>
			</button>
		`;
	}

	return `
		<article class="dc-product-card" data-product-id="${id}">
			<div class="dc-product-card__media">
				<a href="${escapeHtml(product.permalink)}" class="dc-product-card__image-link" tabindex="-1" aria-hidden="true">
					<img class="dc-product-card__image" src="${escapeHtml(product.image)}" alt="" loading="lazy" width="300" height="300">
				</a>
				<button
					type="button"
					class="dc-product-card__favourite"
					data-favourite-toggle
					data-product-id="${id}"
					data-product-name="${escapeHtml(product.name)}"
					aria-pressed="false"
					aria-label="Add to favourites"
				>
					<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="currentColor"/></svg>
				</button>
			</div>
			<div class="dc-product-card__body">
				<h3 class="dc-product-card__title">
					<a href="${escapeHtml(product.permalink)}">${escapeHtml(product.name)}</a>
				</h3>
				<div class="dc-product-card__price">${product.price_html || ''}</div>
				<p class="dc-product-card__stock dc-product-card__stock--${stockClass}">${stockLabel}</p>
				${action}
			</div>
		</article>
	`;
}

/**
 * @param {HTMLElement} container
 * @param {Record<string, unknown>[]} products
 */
export function renderProductCards(container, products) {
	if (!container) {
		return;
	}

	if (!products?.length) {
		container.innerHTML = '';
		return;
	}

	container.innerHTML = products.map((product) => renderProductCard(product)).join('');
	syncFavouriteButtons();
}
